<template>
  <div
      class="product-modal"
      v-bind="bindContainer"
  >

    <div class="row q-col-gutter-x-md q-col-gutter-x-lg-lg">

      <div class="col-24 col-md-11">

        <div class="flex column no-wrap" style="position: sticky; top:0;">

          <div class="c-media">

            <div class="c-media__top q-px-sm q-pt-sm flex">
              <div class="__left">
                <ProductFlags
                    v-if="flags.length"
                    :items="flags"
                    :product="product"
                    class=""
                />
              </div>
              <div class="__right">
                <ProductActions
                    :product="product"
                    class="q-ml-auto"
                />
              </div>
            </div>

            <div class="c-media__thumb text-center">
              <q-img
                  v-if="!debugOptions.disableImages"
                  fit="contain"
                  :src="imageUrl"
                  class="c-media__thumb__img"
                  :ratio="4/3"
              />
            </div>

          </div>

          <ProductActionsDetail
              :product="product"
              class="q-mb-md"
          />

        </div>

      </div>

      <div class="col-24 col-md-13 flex column no-wrap">

        <h1 class="i-title s-font-sm-2xl s-font-md-3xl s-font-lg-4xl s-font-xl-4xl text-weight-bolder leading-e4 q-ma-none q-m">
          {{ product.NAME }}
        </h1>

        <!-- Feature Labels - Requirements: 3.1 -->
        <div
            v-if="hasFeatures && false"
            class="c-feature-labels q-mt-sm flex q-gutter-xs"
        >
          <FeatureLabel
              v-for="feature in productFeatures"
              :key="feature.ID"
              :feature="feature"
              :show-schedule="true"
          />
        </div>

        <div
            v-if="descTeaser"
            class="i-teaser q-mt-md" v-html="descTeaser"
        />

        <ProductSetItemsDetails
            :product="product"
            :items="setItems"
            v-if="!!setItems.length"
            class="q-mt-md"
        />

        <Chemistry
            v-if="product.PROPERTIES.BELKI"
            :product="product"
        />

        <div class="q-pt-md">
          <ProductModificators
              v-if="modificatorsByPosition['card-sale']"
              :modificators="modificatorsByPosition['card-sale']"
              :basket-item="basketItem as any"
              class="q-gutter-y-md"
          />

          <!-- Информация о недоступности товара-опции модификатора -->
          <!-- Requirements: 4.2, 4.5 - Показываем только для restricted товаров -->
          <ModificatorRequirement
              v-if="hasRestrictedModificators && !isAvailableToAdd"
              mode="detailed"
              :regular-modificator-options="detailedModificatorRequirements.regular"
              :global-modificator-options="detailedModificatorRequirements.global"
          />
        </div>

        <div v-if="!isSheet" class="bg-white q-mt-auto q-pt-md q-mb-sm" style="position:sticky;bottom:0;">
          <div class="row q-col-gutter-md items-center" v-if="!product.IS_SALE_SPECIAL">

            <div class="col-12 q-mr-auto" v-if="priceAvailable">

              <div class="col-auto flex items-center q-gutter-sm ">

                <div class="i-price leading-none flex">

                  <div
                      class="i-price__discounted s-font-4xl leading-none text-weight-bold"
                      v-html="formatPrice(calc.price)"
                  />

                </div>

                <div
                    v-if="weight"
                    class="i-measure text-grey-6 leading-none q-ml-md"
                >
                  /&nbsp;&nbsp;{{ weight }} гр.
                </div>

              </div>

            </div>

            <div class="col-12 flex items-center" v-if="isAvailableToAdd">

              <q-btn
                  class="full-width"
                  color="primary"
                  dense
                  label="в корзину"
                  unelevated
                  @click="onBasketAdd"
                  :loading="basketMutating"
                  v-if="!inBasket"
              />
              <div v-else class="flex full-width">
                <QuantityInput
                    :model-value="basketItem.fields.QUANTITY"
                    @update:model-value="onBasketQuantity"
                    :btnOutline="true"
                    :show-action-tooltip="true"
                    btnSize="14px"
                    class="c-quantity q-ml-auto"
                    controlClass="q-gutter-xs"
                    :btn="{
                        color: 'primary',
                        outline: false,
                        class: 'q-px-md'
                      }"
                />
              </div>

            </div>

          </div>
        </div>

      </div>

    </div>

    <div class="bg-white" style="position:sticky;bottom:0;" v-if="isSheet">

      <div class="q-py-md">

        <div class="row q-col-gutter-md items-center" v-if="!product.IS_SALE_SPECIAL">

          <div class="col-12 q-mr-auto" v-if="priceAvailable">

            <div class="col-auto flex items-center q-gutter-sm ">

              <div class="i-price leading-none flex">

                <div
                    class="i-price__discounted s-font-4xl leading-none text-weight-bold"
                    v-html="formatPrice(calc.price)"
                />

              </div>

              <div
                  v-if="weight"
                  class="i-measure text-grey-6 leading-none q-ml-md"
              >
                /&nbsp;&nbsp;{{ weight }} гр.
              </div>

            </div>

          </div>


          <div class="col-12 flex items-center" v-if="isAvailableToAdd">

            <q-btn
                class="full-width"
                color="primary"
                dense
                label="в корзину"
                unelevated
                @click="onBasketAdd"
                :loading="basketMutating"
                v-if="!inBasket"
            />
            <div v-else class="flex full-width">
              <QuantityInput
                  :model-value="basketItem.fields.QUANTITY"
                  @update:model-value="onBasketQuantity"
                  :btnOutline="true"
                  :show-action-tooltip="true"
                  btnSize="14px"
                  class="c-quantity q-ml-auto"
                  controlClass="q-gutter-xs"
                  :btn="{
                        color: 'primary',
                        outline: false,
                        class: 'q-px-md'
                      }"
              />
            </div>

          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script setup lang="ts">
import Chemistry from "@/components/Shop/ProductCard/ui/Chemistry.vue";
import ModificatorRequirement from "@/components/Shop/ProductCard/ui/ModificatorRequirement.vue";
import ProductSetItemsDetails from "@/components/Shop/ProductCard/ui/SetItemsDetails.vue";
import ProductModificators from "@/components/Shop/ProductModificator/ProductModificators.vue";
import QuantityInput from "@/components/Ui/QuantityInput.vue";
import { useAlerts } from "@/core/store/alerts";
import { useDebugStore } from "@/core/store/debug";
import { useCurrency } from "@/modules/shop/store/currency";
import { TStackItemModalModes } from "@/packages/stack-router/types";
import { storeToRefs } from "pinia";
import { computed, toRefs } from "vue";
import { ProductCardProps, useProductView } from "./hooks";
import ProductActions from "./ui/Actions.vue";
import ProductActionsDetail from "./ui/ActionsDetail.vue";
import FeatureLabel from "./ui/FeatureLabel.vue";
import ProductFlags from "./ui/Flags.vue";

export type ProductCardPropsModal = ProductCardProps & {
  mode: TStackItemModalModes,
  basketItemUuid?: string
}

const props = withDefaults(defineProps<ProductCardPropsModal>(), {})

const {mode} = toRefs(props)

const isSheet = computed(() => mode.value === 'sheet')

const {
  onClick,
  product,
  onBasketAdd,
  onBasketQuantity,
  weight,
  basketItem,
  bindContainer,
  view,
  flags,
  imageUrl,
  bindLinkComponent,
  bindLink,
  bindLinkListeners,
  descTeaser,
  basketMutating,
  priceAvailable,
  calc,
  setItems,
  inBasket,
  isAvailableToAdd,
  onCreateNewBasketItem,
  modificatorsByPosition,
  modificators,
  modificatorsChild,
  productAsGlobalModificatorOption,
  isModificatorOption,
  currentBasketItemUuid,
  productFeatures,
  hasFeatures,
  // Новое API - состояния модификаторов
  hasRestrictedModificators,
  detailedModificatorRequirements,
} = useProductView(props, {
  calcOptions: {
    round: true
  },
})

const {formatPrice} = useCurrency()

// Debug store для опций отладки
const debugStore = useDebugStore();
const {debugOptions} = storeToRefs(debugStore);

const {showAlerts} = useAlerts()

</script>

<style scoped lang="scss">
.c-media {
  position: relative;
  background-color: #efefef;
}

.c-media__top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  display: flex;

  .__left {
  }

  .__right {
    margin-left: auto;
  }
}
</style>
